import { useEffect, useState } from 'react'
import { useAlert } from 'react-alert'

import { ClinicsModel, MeModel } from '../../../domain/models'
import {
  deleteClinics,
  fetchListAll,
  fetchMe,
  updateMe
} from '../../../main/usecases'

import { setUser } from '../../utils'
import { useModalBox, useOnChangeDetect } from '../../contexts'
import { Button } from '../../components'
import { ClinicsCard, DataCard, HeaderLinks, TitleCard } from './components'

import { IconSaveSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'
import CompleteModal from '../../components/complete-modal'

const MyData = () => {
  const { modalBox } = useModalBox()
  const [data, setData] = useState<MeModel>({} as MeModel)
  const [clinics, setClinics] = useState<any[]>([])
  const [dataClinics, setDataClinics] = useState<ClinicsModel>(
    {} as ClinicsModel
  )
  const alert = useAlert()
  const { setRefresh, refresh } = useOnChangeDetect()

  const handleAddClinic = () => {
    setClinics([...clinics, { clinics: '' }])
  }

  const handleRemove = async ({ item, position }: any) => {
    try {
      if (item?.cdClinica) {
        await deleteClinics(item?.cdClinica).delete()
        alert.show(`Endereço deletado com sucesso`, {
          type: 'success',
          timeout: 1000
        })
        setClinics([])
      } else if (position >= 0) {
        setClinics((prev: any) =>
          prev.filter((_: any, i: any) => i !== position)
        )
      }
      setRefresh((prev: any) => !prev)
    } catch (error) {
      console.error(error)
      alert.show(`Erro ao deletar um endereço`, {
        type: 'error',
        timeout: 4000
      })
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        const responseToMe = await fetchMe().load()

        setData(responseToMe)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [refresh])

  useEffect(() => {
    setClinics([])

    let objClinics: any = {}

    data?.clinicas?.forEach((item: any, index: number) => {
      objClinics = { ...objClinics, [index]: item }
      setClinics((prev) => [...prev, { address: '' }])
    })

    setDataClinics(objClinics)
  }, [data])

  const onSubmit = async (event: any) => {
    if (
      !data?.usuario?.nome ||
      !data?.usuario?.email ||
      !data?.cpf ||
      !data?.contato?.contato
    ) {
      alert.show('Preencha todos os campos obrigatórios', {
        type: 'error',
        timeout: 4000
      })
      return
    }
    const body = {
      usuario: {
        cdUsuario: data?.usuario?.cdUsuario,
        nome: data?.usuario?.nome,
        email: data?.usuario?.email
      },
      cpf: data?.cpf,
      crp: data?.crp,
      sexo: data?.sexo,
      contato: {
        contato: data?.contato?.contato
      },
      clinicas: Object.values(dataClinics || {}).map((clinics: any) => ({
        ...clinics
      }))
    }
    event.preventDefault()
    try {
      const response = await updateMe().update(body)
      await setUser(response)
      setData(response)
      alert.show('Dados salvos com sucesso', {
        type: 'success',
        timeout: 4000
      })
      const myCustomer = await fetchListAll({ page: 1 }).load()
      console.log(myCustomer)
      if (!myCustomer.totalElements) {
        modalBox(<CompleteModal />, null, '40%', 'auto', true)
      }
    } catch (error) {
      alert.show((error as Error).message || 'Erro ao salvar dados', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  return (
    <S.Wrapper>
      <S.Title>Dados da conta</S.Title>
      <S.CardContainer onSubmit={onSubmit}>
        <form action="#">
          <HeaderLinks
            routes={['/meus-dados', '/alterar-senha', '/meu-faturamento']}
          >
            <Button
              type="submit"
              onClick={(e: any) => onSubmit(e)}
              initialIcon={<IconSaveSvg />}
            >
              Salvar
            </Button>
          </HeaderLinks>

          <DataCard data={data} setData={setData} />

          <TitleCard title="Endereços">
            <Button
              onClick={handleAddClinic}
              type="button"
              title="Adicionar mais um endereço"
            >
              +
            </Button>
          </TitleCard>
          {clinics.map((_, index) => (
            <ClinicsCard
              key={index}
              onChangeComponent={(item: any) => {
                setDataClinics((prev: any) => {
                  if (!prev) return prev

                  return { ...prev, [index]: item }
                })
              }}
              defaultValue={data?.clinicas?.length && data?.clinicas[index]}
              onDelete={() => {
                handleRemove({
                  item: Object.values(dataClinics || {}).find(
                    (clinics: any, i: any) => {
                      if (i === index) {
                        return clinics
                      }
                      return null
                    }
                  ),
                  position: index
                })
              }}
            />
          ))}

          <S.ButtonContainer>
            <Button
              type="submit"
              initialIcon={<IconSaveSvg />}
              onSubmit={onSubmit}
            >
              Salvar
            </Button>
          </S.ButtonContainer>
        </form>
      </S.CardContainer>
    </S.Wrapper>
  )
}

export default MyData
